import { RecentLocationByDeliveryDto } from "../../../types/delivery/delivery-dto";
import { convertRecentLocationByDeliveryDtoToRecentLocationByDelivery } from "../../../utils/converter/delivery/delivery-converter";
import { DeliveryState } from "../../type/delivery-state";

interface Action {
  type: string;
  payload: {
    recentLocationByDeliveryDto: RecentLocationByDeliveryDto;
  };
}

export const setRecentLocationByDeliveryDispatch = (
  state: DeliveryState,
  action: Action
) => {
  const { recentLocationByDeliveryDto } = action.payload;
  state.recentLocationByDelivery =
    convertRecentLocationByDeliveryDtoToRecentLocationByDelivery(
      recentLocationByDeliveryDto
    );
};
